<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<div v-if="infoData" class="block_1">
				<div class="block_1_main">
					<!--引导块-->
					<div class="tips_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ infoData.title }}
					</div>
					<!--引导块-->
					<!--banner-->
					<div class="banner_box">
						<div class="right"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img :src="require('@/assets/poc/thumb.png')" />
						</div>
						<div class="left"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="tit1">
								<span class="col_b">CorDx</span>&ensp;
								<span class="col_o">Tyfast</span>
							</div>
							<div class="tit2 col_b">Flu A/B & COVID-19</div>
							<div class="tit3">Multiplex Rapid Test</div>
							<div class="tit4 col_o">Authorized for Emergency Use (EUA)</div>
							<div class="tit4 col_o">24months *3in1 shelf life has extended to 24 months</div>
							<div class="tips_main_box">
								<div class="tips_el">
									<img class="tips_img" src="../../assets/img_public/20240110_1.png" /><span>Nasal Swab</span>
								</div>
								<div class="tips_el">
									<img class="tips_img" src="../../assets/img_public/20240110_2.png" /><span>Use-Friendly</span>
								</div>
								<div class="tips_el">
									<img class="tips_img" src="../../assets/img_public/20240110_3.png" /><span>Multi Target</span>
								</div>
							</div>
							<div class="txt">
								The CorDx Tyfast Flu A/B & COVID-19 Multiplex Rapid Test is a lateral flow immunoassay intended for the qualitative detect and differentiate of SARS-CoV-2 and influenza A and B antigens in nasal samples(from both nostrils). The test provides an efficient and accurate diagnostic solution in just 10 mins, giving people fast way to prioritize their health. 
							</div>
							<div class="btn_box_more" @click="goFreeSample">
								Get a Quote
							</div>
						</div>
					</div>
					<!--banner-->
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="right"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/poc/block_1.png" />
					</div>
					<div class="left">
						<div class="tit1"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>Empowering Healthcare Professionals</div>
						<div class="tit1 col_o"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="400"
							data-aos-offset="0"
							data-aos-once="true"
						>Rapid, Comprehensive, Precise Results</div>
						<div class="txt"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
						>
							CorDx Tyfast Multiplex Rapid Test equips point-of-care professionals with world-class, reliable diagnostics that streamlinetheir ability to provide care and deliver peace-of-mind
						</div>
						<div class="list_box"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="600"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="tit col_o">CPT Codes</div>
							<div class="list_el">
								<div class="l">Flu A/B & COVID-19</div>
								<div class="r" style="padding-top: 26px;">87428-QW</div>
							</div>
							<div class="list_el">
								<div class="l">COVID-19</div>
								<div class="r">87811QW</div>
							</div>
							<div class="list_el">
								<div class="l">Flu A</div>
								<div class="r">87804QW</div>
							</div>
							<div class="list_el">
								<div class="l">Flu B</div>
								<div class="r">87804QW-59</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_main">
					<div class="right"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/poc/block_2.png" />
					</div>
					<div class="left">
						<div class="tit1"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>Flu A/B & COVID-19 Ag</div>
						<div class="tit1 col_o"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="400"
							data-aos-offset="0"
							data-aos-once="true"
						>Control Swab Kit</div>
						<div class="txt"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-once="true"
						>
							The CorDx Tyfast Flu A/B & COVID-19 Multiplex Control Swab kit is intended to be used for quality control testing of the CorDx Tyfast FlU A/B & COVID-19 Multiplex Rapid Test.
						</div>
						<div class="list_box"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="600"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="tit">Kit Components</div>
							<div class="list_el">
								<div class="l" style="font-weight: bold;">Reagent/Material</div>
								<div class="r" style="font-weight: bold;">Quantity</div>
							</div>
							<div class="list_el">
								<div class="l">Positive Control Swab</div>
								<div class="r">10</div>
							</div>
							<div class="list_el">
								<div class="l">Negative Control Swab</div>
								<div class="r">10</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main">
					<div class="tit1"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Detect and Differentiate Between 
						<span class="col_o">Flu A/B & COVID-19</span>
					</div>
					<div class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>
						CorDx Tyfast gives healthcare professionals the tools to seamlessly detect and differentiate between viral<br />respirator infections, allowing them to make informed treatment decisions.
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="500"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Performance Specifications:</div>
						<div class="table_box">
							<table>
								<tr>
									<td style="width: 40%;"></td>
									<td style="width: 20%;font-weight: bold;">COVID-19</td>
									<td style="width: 20%;font-weight: bold;">FlU A</td>
									<td style="width: 20%;font-weight: bold;">FlU B</td>
								</tr>
								<tr>
									<td style="font-weight: bold;">Positive Percent Agreement (PPA)</td>
									<td>89.6%</td>
									<td>85%</td>
									<td>87.5%</td>
								</tr>
								<tr>
									<td style="font-weight: bold;">Negative Percent Agreement (NPA)</td>
									<td>99.8%</td>
									<td>99.2%</td>
									<td>99.8%</td>
								</tr>
							</table>
						</div>
						<div class="tips">*Based on the multi-site clinical study conducted in the Us.</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main">
					<div class="tit1"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Benefits of Multiplex Testing at the 
						<span class="col_o">Point-of-Care</span>
					</div>
					<div class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>
						There are many pros surrounding the use of multiplex tests that introduce positive benefits for healthcare facilities as well as the patients they serve. These benefits introduce efficiency to healthcare processes and higher-quality results for individuals.
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="500"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el">
							<img src="../../assets/poc/block_3.png" />
							<div>Fever or Chills</div>
						</div>
						<div class="list_el">
							<img src="../../assets/poc/block_4.png" />
							<div>Coughs</div>
						</div>
						<div class="list_el">
							<img src="../../assets/poc/block_5.png" />
							<div>Dlfficulty Breathing</div>
						</div>
						<div class="list_el">
							<img src="../../assets/poc/block_6.png" />
							<div>Fatigue</div>
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--块6-->
			<div class="block_6">
				<div class="tit1"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				>
					CorDx is Committed to 
					<span class="col_o">Trust and Quality</span>
				</div>
				<div class="txt"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
				>
					CorDx is committed to providing diagnostic products of the highest caliber of quality for caregivers, for families, and for you. With world-renowned quality management systems across our global network, CorDx delivers reliable, precise diagnostic products.
				</div>
			</div>
			<!--块6-->
			<!--块7-->
			<template v-if="infoData">
				<div v-if="infoData.tags.length > 0" class="block_7"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Downloadable Resources</div>
					<div class="list_box">
						<div v-for="(value, index) in infoData.tags" :key="index"
							class="list_el"
							:class="nowList == value.id ? 'actived' : ''"
							@click="listClick(value)"
						>{{ value.catname }}</div>
					</div>
					<div class="content" v-html="nowContent"></div>
				</div>
			</template>
			<!--块7-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import contact from '@/component/contact2.vue'  //联系我们
import { productInfo, productCount  } from '@/api/public_h5';
import md5 from 'js-md5';
import { ImagePreview } from 'vant';  //图片放大
import moment from 'moment';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			nowList: null,
			nowContent: '',
			metaDescription: '',
			metaKeywords: '',
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求产品信息
		productInfo({
			custom: that.$route.params.productInfoIds,
		}).then(res => {
			that.infoData = res.data;
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			if(that.infoData.tags.length > 0) {
				that.nowList = that.infoData.tags[0].id;
				that.nowContent = that.infoData.tags[0].content;
			}
			that.isLoading = false;
			//统计访问
			let time = String(moment(new Date()).valueOf());
			setTimeout(() => {
				productCount({
					language: sessionStorage.getItem('lang') == 'en' ? 2 : 1,
					cate_id: that.infoData.cate_id,
					cert_id: that.infoData.cert_id,
					productid: that.infoData.id,
					url: that.$route.name,
					addtime: time,
					sign: md5(String(that.infoData.cate_id) + String(that.infoData.cert_id) + String(that.infoData.id) + that.$route.name + String(time) + 'CorDx2023'),
				}).then(res2 => {});
			}, 10000);
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		goFreeSample() {
			window.location.href = 'https://9503031.extforms.netsuite.com/app/site/crm/externalleadpage.nl/compid.9503031/.f?formid=1&h=AAFdikaIQ2PXFz401i3VE_HOLtHYK7BnQWKsJ4kggWf6fmweWho&redirect_count=1&did_javascript_redirect=T';
		},
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		//底部列表点击
		listClick(value) {
			let that = this;
			that.nowList = value.id;
			that.nowContent = value.content;
		},
		goBuyUrl() {
			let that = this;
			window.location.href = that.infoData.buy_url;
		},
	}
}
</script>

<style lang="less" scoped>
.col_o{
	color: #f36f32;
}
.col_b{
	color: #083388;
}
.main_box{
	width: 100%;
	height: auto;
	//块7
	.block_7{
		padding: 30px 20px;
		.tit{
			padding-bottom: 30px;
			font-size: 20px;
			font-weight: bold;
			text-align: center;
		}
		.content{
			padding: 0 20px;
			border: 1px solid #0B318F;
		}
		.list_box{
			.list_el{
				display: inline-block;
				margin: 0 10px 20px 0;
				padding: 10px 20px;
				font-size: 18px;
				background-color: #EFEFEF;
				color: #000000;
				cursor: pointer;
			}
			.list_el.actived{
				color: #ffffff;
				background-color: #0B318F;
			}
		}
	}
	//块6
	.block_6{
		padding: 50px 20px;
		background-color: #d0edff;
		.txt{
			padding-top: 10px;
			font-size: 18px;
			text-align: center;
		}
		.tit1{
			font-size: 24px;
			font-weight: bold;
			text-align: center;
			span{
				font-size: 24px;
				font-weight: bold;
				color: #0B318F;
			}
		}
	}
	//块5
	.block_5{
		width: 100%;
		margin-top: 20px;
		// background: url(../../assets/poc/bg2.png) no-repeat 100% 100%;
		// background-size: contain;
		.block_5_main{
			padding: 0px 20px 35px 20px;
			.list_box{
				padding-top: 30px;
				.list_el{
					padding: 15px 50px;
					img{
						width: 100%;
					}
					div{
						padding-top: 15px;
						font-size: 20px;
						text-align: center;
					}
				}
			}
			.txt{
				padding-top: 10px;
				font-size: 18px;
				text-align: center;
			}
			.tit1{
				font-size: 24px;
				font-weight: bold;
				text-align: center;
				span{
					font-size: 24px;
					font-weight: bold;
				}
			}
		}
	}
	//块4
	.block_4{
		width: 100%;
		margin: 0 auto;
		margin-top: 20px;
		// background: url(../../assets/poc/bg1.png) no-repeat 100% 100%;
		// background-size: contain;
		.block_4_main{
			padding: 0px 20px 50px 20px;
			.list_box{
				padding-top: 30px;
				.table_box{
					table{
						width: 100%;
						border-collapse: collapse;
					}
					table, th, td{
						border: 1.5px solid #707070;
					}
					th, td {
						padding: 8px 8px;
						text-align: center;
					}
				}
				.tips{
					font-size: 16px;
				}
				.tit{
					font-size: 24px;
					font-weight: bold;
				}
			}
			.txt{
				padding-top: 10px;
				font-size: 18px;
				text-align: center;
			}
			.tit1{
				font-size: 24px;
				font-weight: bold;
				text-align: center;
				span{
					font-size: 24px;
					font-weight: bold;
				}
			}
		}
	}
	//块3
	.block_3{
		width: 100%;
		margin: 0 auto;
		// background: url(../../assets/poc/bg2.png) no-repeat 100% 100%;
		// background-size: contain;
		.block_3_main{
			width: 100%;
			padding: 0px 20px 50px 20px;
			align-items: center;
			.left{
				width: 100%;
				.list_box{
					width: 100%;
					padding-top: 20px;
					border-bottom: 1.5px solid #707070;
					.list_el{
						display: flex;
						.r{
							flex: 0.8;
							padding: 10px 15px;
							font-size: 20px;
							text-align: center;
							border-top: 1.5px solid #707070;
							border-right: 1.5px solid #707070;
							border-bottom: 0px solid #707070;
							border-left: 1.5px solid #707070;
						}
						.l{
							flex: 1.5;
							padding: 10px 15px;
							font-size: 20px;
							text-align: center;
							border-top: 1.5px solid #707070;
							border-bottom: 0px solid #707070;
							border-left: 1.5px solid #707070;
						}
					}
					.tit{
						font-size: 18px;
						font-weight: bold;
					}
				}
				.txt{
					padding-top: 18px;
					font-size: 18px;
				}
				.tit1{
					font-size: 24px;
					font-weight: 900;
				}
			}
			.right{
				width: 100%;
				text-align: center;
				img{
					width: 100%;
				}
			}
		}
	}
	//块2
	.block_2{
		width: 100%;
		max-width: 1500px;
		margin: 0 auto;
		margin-top: 0px;
		// background: url(../../assets/poc/bg1.png) no-repeat 100% 100%;
		// background-size: cover;
		.block_2_main{
			width: 100%;
			margin: 0 auto;
			padding: 50px 20px;
			align-items: center;
			.left{
				width: 100%;
				.list_box{
					width: 100%;
					padding-top: 20px;
					border-bottom: 1.5px solid #707070;
					.list_el{
						display: flex;
						.r{
							flex: 1.5;
							padding: 10px 15px;
							font-size: 18px;
							text-align: center;
							border-top: 1.5px solid #707070;
							border-right: 1.5px solid #707070;
							border-bottom: 0px solid #707070;
							border-left: 1.5px solid #707070;
						}
						.l{
							flex: 0.8;
							padding: 10px 15px;
							font-size: 18px;
							border-top: 1.5px solid #707070;
							border-bottom: 0px solid #707070;
							border-left: 1.5px solid #707070;
						}
					}
					.tit{
						font-size: 26px;
						font-weight: bold;
					}
				}
				.txt{
					padding-top: 18px;
					font-size: 18px;
				}
				.tit1{
					padding-top: 10px;
					font-size: 24px;
					font-weight: 900;
				}
			}
			.right{
				width: 100%;
				text-align: center;
				img{
					width: 120px;
				}
			}
		}
	}
	//块1
	.block_1{
		.block_1_main{
			width: 100%;
			margin: 0 auto;
			padding: 0 20px 20px 20px;
			background: linear-gradient(90deg,#f2f7fd,transparent);
			.banner_box{
				.left{
					width: 100%;
					.btn_box_more{
						display: inline-block;
						padding: 2px 60px 0 60px;
						height: 42px;
						line-height: 42px;
						font-size: 18px;
						color: #ffffff;
						background: #0B318F;
						border-radius: 22px 22px 22px 22px;
						border: 1px solid #0B318F;
						text-align: center;
						cursor: pointer;
					}
					.txt{
						padding: 0px 0 30px 0;
						font-weight: bold;
						font-size: 16px;
					}
					.tips_main_box{
						margin: 20px 0;
						.tips_el{
							padding: 10px 0;
							span{
								position: relative;
								top: 4px;
								color: #0B318F;
								font-size: 18px;
								font-weight: bold;
							}
							.tips_img{
								width: 30px;
								margin-right: 6px;
							}
						}
					}
					.tit4{
						padding: 12px 0 0 0;
						font-size: 18px;
						font-weight: bold;
					}
					.tit3{
						font-size: 30px;
					}
					.tit2{
						font-size: 40px;
						font-weight: 900;
					}
					.tit1{
						padding-top: 30px;
						span{
							font-size: 30px;
							font-weight: bold;
						}
					}
				}
				.right{
					width: 100%;
					img{
						width: 100%;
					}
				}
			}
			.tips_box{
				padding: 50px 0;
				font-size: 18px;
				font-weight: bold;
				span{
					font-size: 18px;
					color: rgb(40, 142, 207);
					font-weight: bold;
				}
			}
		}
	}
}
</style>
